﻿export const config = {
  SITE: import.meta.env.VITE_SITE || 'LS',
  LANG: import.meta.env.VITE_LANG || 'it',
  NOME_APP: import.meta.env.VITE_NOME_APP || 'LMEET',
  NUMELEM: parseInt(import.meta.env.VITE_NUMELEM || '25'),
  WSREST_TABATA: import.meta.env.VITE_WSREST_TABATA || '',
  MAP_API_KEY: import.meta.env.VITE_MAP_API_KEY || '',
  VAPID_PUBLIC_KEY: import.meta.env.VITE_VAPID_PUBLIC_KEY || '',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const;
